<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="text-uppercase">{{ $t('degrees.outdated') }}</h3>
                    <small class="text-muted">{{ $t('degrees.outdated-meaning', { age: dataConservation }) }}</small>
                    <p class="text-sm mt-3" v-if="empty">{{ $t('degrees.no-degree') }}</p>
                </div>
                <div class="col-6 text-right">
                    <base-button type="danger" size="sm" @click="deleteAll()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-simple-remove"></i></span>
                        <span class="btn-inner--text">{{ $t('common.delete-all') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <div class="pt-2" v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column :label="$t('common.name')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="open(row)">
                                {{ row.name }}
                            </a>
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.edition')">
                    <template v-slot="{row}">
                        <small v-if="row.edition">
                            {{ row.edition }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.code')">
                    <template v-slot="{row}">
                        {{ row.code }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.lang')">
                    <template v-slot="{row}">
                        {{ row.lang }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.owner')">
                    <template v-slot="{row}">
                        {{ owners[row.owner_id] }}
                        <span v-if="row.shared">
                            <i class="fas fa-share ml-1"></i>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="60" class-name="actions">
                    <template v-slot="{row}">
                        <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </a>
                    </template>
                </el-table-column>

            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('degrees.delete-confirm') }}</p>
            </confirm-modal>

            <confirm-modal v-model="ctrl.modals.confirmDeleteAll">
                <p>{{ $t('degrees.delete-all-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'

    export default {

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/socrates/api/front/degrees',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    modals: ['confirmDeleteAll'],
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['-created_at', 'name'],
                        include: ['owners'],
                        filters: { outdated: true },
                    },
                    errors: {
                        '423-delete': 'degrees.423-delete',
                    }
                }),
                search: '',
                owners: {},
                next: false
            }
        },

        computed: {

            dataConservation() {
                return this.$auth['config'].data_conservation
            },

            empty() {
                return this.ctrl.rows.length ==0 && !this.search
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.owners = Array.isArray(resp.data.included.owners) ? {} : resp.data.included.owners
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ name: {$text: val} })
            }
        },

        methods: {
            
            deleteAll() {
                this.ctrl.modals.open('confirmDeleteAll').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        this.$loader.show()
                        axios.delete(
                            '/socrates/api/front/degrees',
                            { params: { filters: { outdated: true } }}
                        )
                        .then(response => {
                            this.ctrl.list()
                            this.$loader.hide()
                        }).catch(error => {
                            this.ctrl.list()
                            this.$loader.hide()
                            //this.$auth.handleErrorVm(error, this)
                        })
                    }
                })
            },

            open(row) {
                this.$router.push({ name: 'admin-degree', params: { id: row.id } })
            },

            mapData(degree) {
                return {
                    id: degree ? degree.id : null,
                    name: degree ? degree.name : null,
                    description: degree ? degree.description : null,
                    code: degree ? degree.code : null,
                    status: degree ? degree.status : null,
                    edition: degree ? degree.edition : null,
                    shared: degree ? degree.shared : false,
                    main_notification: degree ? degree.main_notification : null,
                    gppos_notification: degree ? degree.gppos_notification : null,
                    simulation_role_1: degree ? degree.simulation_role_1 : null,
                    simulation_role_2: degree ? degree.simulation_role_2 : null,
                    simulation_role_1_name: degree ? degree.simulation_role_1_name : null,
                    simulation_role_2_name: degree ? degree.simulation_role_2_name : null,
                    grid1_id: degree ? degree.grid1_id : null,
                    grid1: degree ? degree.grid1 : null,
                    grid2_id: degree ? degree.grid2_id : null,
                    grid2: degree ? degree.grid2 : null,
                    lang: degree ? degree.lang : 'en',
                    rating_scale: degree ? degree.rating_scale : '6levels',
                    import_deleted: degree ? degree.import_deleted : false,
                    owner_id: degree ? degree.owner_id : null,
                }
            },

            unmapData(data) {
                return data
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }

</style>
